(function() {
  var Service,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.ProductsService = (function(superClass) {
    extend(ProductsService, superClass);

    function ProductsService(http, rootScope) {
      this.http = http;
      this.rootScope = rootScope;
      void 0;
    }

    ProductsService.prototype.all = function() {
      return this.http.post('backend/grower/layers/planting-rx/ng-products');
    };

    ProductsService.prototype.bySeedCompany = function(id, field_id, crops_id, selected) {
      if (selected == null) {
        selected = [];
      }
      return this.http.post('backend/grower/layers/planting-rx/ng-products', {
        'seed_company_id': id,
        'field_id': field_id,
        'crops_id': crops_id,
        'selected_ids': selected
      });
    };

    ProductsService.prototype.treatments = function(id, spp_id) {
      return this.http.post('backend/grower/layers/planting-rx/ng-treatments', {
        'brands_id': id,
        'spp_id': spp_id
      });
    };

    return ProductsService;

  })(Service);

}).call(this);
